export default __webpack_public_path__ + "static/media/icon-canceled.5d11ef4e.svg";